import { ACTION_TYPES, DEFAULT_ERROR_STATE } from "./constants.js";
const quantitySelectorReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.CHANGE: {
      return {
        ...state,
        prevQty: state.quantityInput,
        quantityInput: (payload == null ? void 0 : payload.newQuantity) ?? "",
        liveRegionText: (payload == null ? void 0 : payload.liveRegionText) || ""
      };
    }
    case ACTION_TYPES.SET_CURRENT_VALUE: {
      return {
        ...state,
        showAddToCart: Boolean(payload == null ? void 0 : payload.showAddToCart),
        quantityInput: (payload == null ? void 0 : payload.newQuantity) ?? state.quantityInput,
        addToCartBtnFocus: Boolean(payload == null ? void 0 : payload.addToCartBtnFocus),
        errorState: (payload == null ? void 0 : payload.errorObj) || DEFAULT_ERROR_STATE,
        liveRegionText: (payload == null ? void 0 : payload.liveRegionText) || ""
      };
    }
    case ACTION_TYPES.SET_CUSTOM_ERROR: {
      return {
        ...state,
        errorState: (payload == null ? void 0 : payload.errorObj) || DEFAULT_ERROR_STATE
      };
    }
    default:
      return state;
  }
};
export {
  quantitySelectorReducer
};
